/* Diamond Studio — menu helpers (2026-09-29), every page. Works with both headers (ds-shared-header and
   ds-product-header), which share the same menu markup.
   1. Desktop menu panels: "Make an offer on any piece" next to each panel title.
   2. Desktop service strip: the store rating first, and one concrete line under each promise.
   3. Phone menu: the rating and three promises (offers, shipping, returns) under "Find my match".
   4. Measurement: which menu entries are used (dataLayer "ds_menu_click").
   5. "Shop all <category>" in every jewelry panel: a button in the desktop title row, and a bar that stays at the
      bottom of the phone panel. The top-menu entries only open their panels, so this is the direct way to the category.
   6. Phone menu: a search field at the top (the same search as the magnifier).
   7. Phone menu: "Recently viewed", up to four pieces, for shoppers who have looked at pieces before.
   The "Shop by price" links and featured-piece prices are rendered in snippets/ds-(product-)header-panel.liquid,
   which also gives each jewelry panel its category page (data-ds-mc-all).
   Menus are closed when this runs, so nothing here moves visible content. */
(() => {
  'use strict';
  if (window.DSMenuCRO) return;
  window.DSMenuCRO = {version: '2026-09-29'};

  const svg = body => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + body + '</svg>';
  const ICON = {
    offer: svg('<path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3a1 1 0 0 1 0 1.4l-7.6 7.6a1 1 0 0 1-1.4 0Z"/><circle cx="8" cy="8" r="1.4"/>'),
    ship: svg('<path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.6"/><circle cx="16.5" cy="17" r="1.6"/>'),
    returns: svg('<path d="M8.5 7.5H4V3"/><path d="M4.3 7.5A8 8 0 1 1 4 12"/>'),
    search: svg('<circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.3 15.3 5.2 5.2"/>'),
    arrow: svg('<path d="M4 12h16m-6-6 6 6-6 6"/>')
  };

  function rating() {
    const el = document.getElementById('ds-store-rating-data');
    if (!el) return null;
    try {
      const data = JSON.parse(el.textContent);
      const count = Number(data.count) || 0;
      const value = Number(data.rating) || 0;
      if (count < 1 || value <= 0) return null;
      return {count, value, text: value.toFixed(1), word: count === 1 ? 'review' : 'reviews'};
    } catch (e) { return null; }
  }
  const stars = r => '<span class="ds-sr-stars" style="--ds-sr: ' + r.value + '" aria-hidden="true"></span>';
  const ratingLabel = r => 'Rated ' + r.text + ' out of 5 from ' + r.count + ' customer ' + r.word + '. Read the reviews';

  /* ---------- 1. Desktop panels: the offer promise next to the title ---------- */
  function toplines(root) {
    root.querySelectorAll('#ds-mega [data-dsh-panel] > .menu-topline:not([data-ds-mc])').forEach(line => {
      line.setAttribute('data-ds-mc', '');
      const usp = document.createElement('span');
      usp.className = 'ds-mc-usp';
      usp.innerHTML = ICON.offer + '<span><strong>Make an offer on any piece.</strong> <span>No payment to send one.</span></span>';
      const close = line.querySelector(':scope > [data-dsh-close]');
      if (close) close.before(usp); else line.append(usp);
    });
  }

  /* ---------- 2. Desktop service strip ---------- */
  const STRIP = [
    [/shipping/, 'Free & insured, worldwide'],
    [/return/, '60 days on every piece'],
    [/contact/, 'Personal guidance']
  ];
  function wrapLabel(el, line) {
    const text = [...el.childNodes].filter(n => n.nodeType === 3 && n.textContent.trim());
    if (!text.length) return null;
    const wrap = document.createElement('span');
    wrap.className = 'ds-mc-strip__text';
    const label = document.createElement('span');
    label.textContent = text.map(n => n.textContent.trim()).join(' ');
    text.forEach(n => n.remove());
    const small = document.createElement('small');
    small.textContent = line;
    wrap.append(label, small);
    el.append(wrap);
    return small;
  }
  let savedLine = null;
  function savedText() {
    const badge = document.querySelector('.ds-header-root [data-saved-count]');
    const n = badge && !badge.hidden ? parseInt(badge.textContent, 10) || 0 : 0;
    return n > 0 ? n + (n === 1 ? ' piece saved' : ' pieces saved') : 'Tap the heart to keep a piece';
  }
  function strip(root) {
    const el = root.querySelector('#ds-mega .menu-service-strip');
    if (!el || el.hasAttribute('data-ds-mc')) return;
    el.setAttribute('data-ds-mc', '');
    el.querySelectorAll(':scope > a').forEach(a => {
      const match = STRIP.find(([re]) => re.test(a.pathname));
      if (match) wrapLabel(a, match[1]);
    });
    const saved = el.querySelector(':scope > [data-saved-open]');
    if (saved) savedLine = wrapLabel(saved, savedText());
    const r = rating();
    if (r) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-mc-rating';
      b.setAttribute('data-ds-sr-open', '');
      b.setAttribute('aria-haspopup', 'dialog');
      b.setAttribute('aria-label', ratingLabel(r));
      b.innerHTML = stars(r) + '<span class="ds-mc-strip__text"><span>' + r.text + ' out of 5</span><small>' + r.count + ' customer ' + r.word + '</small></span>';
      el.prepend(b);
    }
    // Keep the saved count current each time the menu opens.
    const mega = document.getElementById('ds-mega');
    if (mega && savedLine) {
      new MutationObserver(() => { if (!mega.hidden) savedLine.textContent = savedText(); })
        .observe(mega, {attributes: true, attributeFilter: ['hidden']});
    }
  }

  /* ---------- 3. Phone menu: rating and promises ---------- */
  function mobile(root) {
    const home = root.querySelector('#ds-mobile-nav .new-mobile-home');
    if (!home || home.querySelector('.ds-mc-promise')) return;
    const anchor = home.querySelector(':scope > .mobile-home-actions') || home.querySelector(':scope > .mobile-finder');
    if (!anchor) return;
    const r = rating();
    const box = document.createElement('div');
    box.className = 'ds-mc-promise';
    box.innerHTML = (r ? '<button type="button" class="ds-mc-promise__rating" data-ds-sr-open aria-haspopup="dialog" aria-label="' + ratingLabel(r) + '">' + stars(r) +
        '<span><strong>' + r.text + '</strong> &middot; ' + r.count + ' customer ' + r.word + '</span></button>' : '') +
      '<ul class="ds-mc-promise__list" role="list">' +
      '<li>' + ICON.offer + '<span><strong>Make an offer on any piece.</strong> No payment to send one.</span></li>' +
      '<li>' + ICON.ship + '<span>Free insured shipping, worldwide</span></li>' +
      '<li>' + ICON.returns + '<span>60-day returns on every piece</span></li>' +
      '</ul>';
    anchor.after(box);
  }

  /* ---------- 4. Measurement ---------- */
  function kindOf(el) {
    if (el.dataset.dsMc) return el.dataset.dsMc;
    if (el.matches('[data-ds-social-network]')) return 'social';
    if (el.matches('[data-dsh-mega], [data-dsh-mobile-section]')) return 'open_panel';
    if (el.matches('[data-open-finder]')) return 'finder';
    if (el.matches('[data-ds-sr-open]')) return 'reviews';
    if (el.matches('[data-saved-open]')) return 'saved';
    if (el.closest('.cut-links')) return 'shape';
    if (el.closest('.setting-links')) return 'setting';
    if (el.classList.contains('menu-product')) return 'product';
    if (el.closest('.guide-links')) return 'guide';
    if (el.closest('.menu-service-strip, .mobile-home-actions')) return 'service';
    if (el.classList.contains('menu-all')) return 'all';
    if (el.closest('.menu-editorial') || el.closest('.new-mobile-home') && el.tagName === 'A') return 'story';
    return el.tagName === 'A' ? 'link' : '';
  }
  // Listens on window in the capture phase: the reviews button's own handler stops the click from travelling further.
  function measure() {
    window.addEventListener('click', event => {
      const el = event.target instanceof Element ? event.target.closest('a, button') : null;
      if (!el || !el.closest('.ds-header-root') || el.matches('[data-dsh-close], [data-dsh-mobile-back], [data-search-open]:not([data-ds-mc])')) return;
      const surface = el.closest('#ds-mobile-nav') ? 'mobile' : el.closest('#ds-mega, .shop-nav-row') ? 'desktop' : '';
      if (!surface) return;
      const kind = kindOf(el);
      if (!kind) return;
      const panel = el.closest('[data-dsh-panel]')?.getAttribute('data-dsh-panel') ||
        el.closest('[data-dsh-mobile-panel]')?.getAttribute('data-dsh-mobile-panel') ||
        el.getAttribute('data-dsh-mega') || el.getAttribute('data-dsh-mobile-section') || 'root';
      const named = el.querySelector('strong') || el;
      const label = (el.getAttribute('aria-label') || named.innerText || named.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: 'ds_menu_click', surface, panel, kind, label});
    }, true);
  }

  /* ---------- 5. "Shop all <category>" ---------- */
  // A menu entry that points to the whole catalog (/collections/all, as Gifts does until it has its own collection)
  // is labelled "Shop all jewelry" rather than promising a category page that does not exist.
  function allLink(url, name, className, kind) {
    const a = document.createElement('a');
    a.className = className;
    a.href = url;
    a.setAttribute('data-ds-mc', kind);
    a.innerHTML = '<span></span>' + ICON.arrow;
    let everything = false;
    try { everything = /\/collections\/all\/?$/.test(new URL(url, location.href).pathname); } catch (e) { /* keep the category name */ }
    a.firstChild.textContent = everything ? 'Shop all jewelry' : 'Shop all ' + name;
    return a;
  }
  function shopAll(root) {
    root.querySelectorAll('.rich-menu-grid[data-ds-mc-all]').forEach(grid => {
      const url = grid.getAttribute('data-ds-mc-all');
      const name = (grid.getAttribute('data-ds-mc-name') || '').trim();
      if (!url || !name) return;
      const desk = grid.closest('#ds-mega [data-dsh-panel]');
      if (desk) {
        const line = desk.querySelector(':scope > .menu-topline');
        if (!line || line.querySelector('.ds-mc-all')) return;
        const a = allLink(url, name, 'ds-mc-all', 'all_top');
        const close = line.querySelector(':scope > [data-dsh-close]');
        if (close) close.before(a); else line.append(a);
        return;
      }
      const phone = grid.closest('[data-dsh-mobile-panel]');
      if (!phone || phone.querySelector(':scope > .ds-mc-sticky')) return;
      const bar = document.createElement('div');
      bar.className = 'ds-mc-sticky';
      bar.append(allLink(url, name, 'ds-mc-sticky__link', 'all_sticky'));
      phone.append(bar);
    });
  }

  /* ---------- 6. Phone menu: search field ---------- */
  // The header's own click handler opens the search for any [data-search-open] inside the header.
  function search(root) {
    const home = root.querySelector('#ds-mobile-nav .new-mobile-home');
    if (!home || home.querySelector(':scope > .ds-mc-search')) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'ds-mc-search';
    b.setAttribute('data-search-open', '');
    b.setAttribute('data-ds-mc', 'search');
    b.innerHTML = ICON.search + '<span>Search rings, earrings, shapes&hellip;</span>';
    home.prepend(b);
  }

  /* ---------- 7. Phone menu: recently viewed ---------- */
  // Same list as the homepage's "Pick up where you left off" (localStorage "ds-recently-viewed-v1"), one piece per
  // design, without the piece on screen. The row is added with empty tiles of the final size while the menu is closed;
  // the pieces are fetched the first time the shopper reaches for the menu, then fill those tiles.
  const RECENT_KEY = 'ds-recently-viewed-v1';
  const familyKey = h => h.replace(/(^|-)\d+(?:-\d{1,2})?-(?:carat|ct)(?=-|$)/, '$1').replace(/-(?:vs1|vs2|vvs1|vvs2)$/, '');
  function recentHandles() {
    let list;
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
    if (!Array.isArray(list)) return [];
    const here = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    const seen = new Set(here ? [familyKey(decodeURIComponent(here))] : []);
    return list.filter(item => item && typeof item.h === 'string' && Date.now() - item.t < 1000 * 60 * 60 * 24 * 60)
      .map(item => item.h)
      .filter(h => { const k = familyKey(h); if (seen.has(k)) return false; seen.add(k); return true; })
      .slice(0, 6);
  }
  const esc = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[ch]));
  function money(cents) {
    const config = window.DS_CRO || {};
    const currency = config.currency || 'USD';
    const pre = currency === 'USD' ? '$' : '';
    const suf = config.country === 'US' && currency === 'USD' ? '' : ' ' + currency;
    return pre + (Number(cents) / 100).toLocaleString('en-US', {maximumFractionDigits: 0}) + suf;
  }
  const root = () => String(window.DS_CRO?.root || '/').replace(/\/?$/, '/');
  const smallImage = src => { const base = String(src).startsWith('//') ? 'https:' + src : String(src); return base + (base.includes('?') ? '&' : '?') + 'width=180'; };
  const ghost = '<li class="ds-mc-recent__ghost" aria-hidden="true"><span class="ds-mc-recent__img"></span><span class="ds-mc-recent__price">&nbsp;</span></li>';
  const tile = p => '<li><a href="' + esc(p.url) + '" data-ds-mc="recent" aria-label="' + esc(p.title + ', ' + money(p.price)) + '">' +
    '<span class="ds-mc-recent__img"><img src="' + esc(smallImage(p.featured_image)) + '" alt="" width="90" height="90" loading="lazy"></span>' +
    '<span class="ds-mc-recent__price">' + esc(money(p.price)) + '</span></a></li>';
  function recent(scope) {
    const home = scope.querySelector('#ds-mobile-nav .new-mobile-home');
    if (!home || home.querySelector(':scope > .ds-mc-recent')) return;
    const handles = recentHandles();
    if (!handles.length) return;
    const section = document.createElement('section');
    section.className = 'ds-mc-recent';
    section.setAttribute('aria-labelledby', 'ds-mc-recent-title');
    section.setAttribute('aria-busy', 'true');
    section.innerHTML = '<p class="ds-mc-recent__title" id="ds-mc-recent-title">Recently viewed</p><ul class="ds-mc-recent__list" role="list">' +
      Array.from({length: Math.min(handles.length, 4)}, () => ghost).join('') + '</ul>';
    const searchField = home.querySelector(':scope > .ds-mc-search');
    if (searchField) searchField.after(section); else home.prepend(section);
    let started = false;
    const load = () => {
      if (started) return;
      started = true;
      Promise.allSettled(handles.map(h => fetch(root() + 'products/' + encodeURIComponent(h) + '.js', {credentials: 'same-origin'}).then(r => r.ok ? r.json() : null)))
        .then(results => {
          const items = results.map(r => r.status === 'fulfilled' ? r.value : null).filter(p => p && p.available && p.featured_image && p.url).slice(0, 4);
          if (!items.length) { section.remove(); return; }
          section.querySelector('.ds-mc-recent__list').innerHTML = items.map(tile).join('');
          section.removeAttribute('aria-busy');
        });
    };
    // Reaching for the menu (touch or mouse down on the menu button) starts the fetch; opening it is the fallback.
    scope.querySelectorAll('[data-dsh-mobile-open]').forEach(b => {
      b.addEventListener('pointerdown', load, {once: true, passive: true});
      b.addEventListener('focus', load, {once: true});
    });
    const dialog = scope.querySelector('#ds-mobile-nav');
    if (dialog) {
      if (dialog.open) load();
      else {
        const observer = new MutationObserver(() => { if (dialog.open) { observer.disconnect(); load(); } });
        observer.observe(dialog, {attributes: true, attributeFilter: ['open']});
      }
    }
  }

  function start() {
    document.querySelectorAll('.ds-header-root').forEach(root => {
      if (root.hasAttribute('data-ds-mc')) return;
      root.setAttribute('data-ds-mc', '');
      toplines(root);
      strip(root);
      mobile(root);
      shopAll(root);
      search(root);
      recent(root);
    });
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
